"use strict";

import EntityList from "./entity-list";

// function nestableListBuilder(nestableFullList, nestableList) {
//     const indexOfFirstObjectOfnestableList = nestableFullList.findIndex(
//         (element) => element.id === nestableList[0].id
//     );

//     const indexOfLastObjectOfnestableList = nestableFullList.findIndex(
//         (element) => element.id === nestableList[nestableList.length - 1].id
//     );

//     const fisrtPartOfFullList = nestableFullList.slice(
//         0,
//         indexOfFirstObjectOfnestableList
//     );

//     const thirdPartpfFullList = nestableFullList.slice(
//         indexOfLastObjectOfnestableList + 1
//     );

//     if (fisrtPartOfFullList.length === 0) {
//         return [...nestableList, ...thirdPartpfFullList];
//     }

//     if (fisrtPartOfFullList.length && thirdPartpfFullList.length) {
//         return [
//             ...fisrtPartOfFullList,
//             ...nestableList,
//             ...thirdPartpfFullList,
//         ];
//     }

//     if (thirdPartpfFullList.length === 0) {
//         return [...fisrtPartOfFullList, ...nestableList];
//     }
// }

class EntityListNestable extends EntityList {
    deleteRecord(e) {
        e.preventDefault();
        if (confirm("Are you sure you want to delete this record?")) {
            const listItem = $(e.target).parents().eq(4);
            if (listItem.find(".dd-list").length) {
                if (confirm("You are deleting children records also.")) {
                    return e.target.submit();
                }

                return false;
            }

            return e.target.submit();
        }

        return false;
    }

    sort(tree = 0) {
        this.entityList.fadeTo("fast", "0.2");

        $.ajax({
            url: this.entityList.data("url") + (tree ? "/" + tree : ""),
            type: "PUT",
            data: { list: this.entityList.nestable("serialize") },
            headers: { "X-CSRF-Token": $('input[name="_token"]').val() },
        })
            .fail((xhr) => {
                alert(xhr.responseJSON.error);
                location.reload();
            })
            .done(() => {
                this.entityList.fadeTo("slow", "1");
            });
    }
}

export default EntityListNestable;
